import { render, staticRenderFns } from "./dialog-change-tags.vue?vue&type=template&id=44d74df7&scoped=true&"
import script from "./dialog-change-tags.vue?vue&type=script&lang=js&"
export * from "./dialog-change-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d74df7",
  null
  
)

export default component.exports